// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"641":"f6a345c4","3479":"b9e69ed1","7650":"9aad834a","8487":"7072fd5c"}[chunkId] + ".chunk.css";
};